import CommonSwiper from '@/components/common/CommonSwiper';
import uiItems from '@/constants/ui-items/index.constants';
import { CommonEnum } from '@/types/translations/CommonEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import Image from 'next/image';
import { SwiperSlide } from 'swiper/react';

export default function IndexBrandsSlider() {
  const { translate: translateCommon } =
    useTypedTranslation<CommonEnum>('common');
  return (
    <div className="tw-flex tw-items-center tw-gap-20 max-nine:tw-gap-4">
      <div className="before:tw-content-[''] before:tw-mr-2 before:tw-w-4 before:tw-h-4 before:tw-bg-[#c2ad7d] before:tw-rounded-full tw-flex tw-items-center">
        <p className="tw-m-0 tw-items-center tw-whitespace-nowrap tw-text-sm">
          <strong className="tw-font-plusJakartaSans tw-font-semibold tw-text-textBlack tw-text-lg max-nine:tw-text-sm">
            {translateCommon(CommonEnum['featured_in'])}
          </strong>
        </p>
      </div>
      <CommonSwiper
        breakpoints={{
          0: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          350: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          450: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          768: {
            slidesPerView: 3.5,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 35,
          },
        }}
        className="!tw-px-2"
      >
        {uiItems.header.menuBrands.map(({ src, alt, href }, index) => (
          <SwiperSlide key={`${index}-${href}`} className="tw-px-2">
            <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
              <div>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={href}
                  aria-label={`go to ${alt}`}
                >
                  <Image
                    width={215}
                    height={32}
                    src={src}
                    alt={alt}
                    priority
                    className="tw-object-contain max-nine:tw-h-4"
                  />
                </a>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </CommonSwiper>
    </div>
  );
}
